/*
 * @Author: yindengli
 * @Date: 2023-06-26 11:04:28
 * @LastEditTime: 2023-10-27 14:29:01
 * @LastEditors: yindengli
 * @Description: 
 * @FilePath: \openseeyon-index-front\src\main.js
 */
import Vue from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import router from './router'
import { Modal } from 'ant-design-vue'
import VueClipboard from 'vue-clipboard2'
import {parseTime} from '@/utils/common'

import vClickOutside from 'v-click-outside'

Vue.use(VueClipboard)

Vue.use(Antd);
Vue.use(vClickOutside);
// 全局方法挂载
Vue.prototype.parseTime = parseTime
Vue.prototype.$comfirm = Modal.comfirm;
Vue.prototype.$error = Modal.error;
Vue.prototype.$warning = Modal.warning;
Vue.prototype.$success = Modal.success;
Vue.prototype.$toLogin = function () {
  window.location.href = `${process.env.VUE_APP_cloudUrl}/c/login?back_url=`+encodeURIComponent(window.location.href) + '&type=open';
}

function getOuterUrl(type) {
  let href = window.location.href;
  if (href.indexOf(type) < 0) {
    return "";
  }

  let url = "";
  if(href.indexOf("share") > -1 && href.split("?").length > 0) {
    url = href.replace("/#", "");
  }

  return url;
}
Vue.prototype.$outerFaqLink = getOuterUrl("faq");
Vue.prototype.$outerToolsLink = getOuterUrl("toolbase");

Vue.config.productionTip = false

Date.prototype.format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份 
    "d+": this.getDate(), //日 
    "h+": this.getHours(), //小时 
    "m+": this.getMinutes(), //分 
    "s+": this.getSeconds(), //秒 
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
    "S": this.getMilliseconds() //毫秒 
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    }
  }
  return fmt;
}

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
